var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{staticStyle:{"min-height":"800px"}},[(_vm.jitsiOptions)?_c('vue-jitsi-meet',{ref:"jitsiRef",attrs:{"domain":"meet.jit.si","options":_vm.jitsiOptions}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }